<!--
  File : ModifyProfile.vue
-->

<template>
  <v-container fluid>
    <v-row justify="center">
      <v-card class="ma-3 elevation-0" width="480">
        <v-toolbar class="elevation-0 mb--20" color="white">
          <v-row justify="center">
            <v-toolbar-title class="primary--text">내 정보 수정</v-toolbar-title>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="mdi-account"
              label="아이디"
              v-model="login.email"
              disabled
            />
            <v-text-field
              prepend-icon="mdi-wallet-membership"
              label="회원구분"
              v-model="util.getItem(this.levels, login.level).text"
              disabled
            />
            <v-text-field
              id="name"
              prepend-icon="mdi-tag"
              type="name"
              label="성명"
              v-model="login.name"
            />
            <v-radio-group row v-model="login.sex">
              <v-icon class="pr-3">mdi-human-male-female</v-icon>
              <v-radio :value=1 label="남"/>
              <v-radio :value=2 label="여" />
            </v-radio-group>
            <v-text-field
              id="birth"
              prepend-icon="mdi-cake-variant"
              :type="util.isAndroid() ? 'text' : 'date'"
              :label="'생년월일' + (util.isAndroid() ? ' (예: 1990-01-01)' : '')"
              v-model="login.birth"
            />
            <v-text-field
              id="mobile"
              type="tel"
              prepend-icon="mdi-cellphone"
              label="휴대폰 번호"
              v-model="login.mobile"
            />
            <v-text-field
              id="address"
              prepend-icon="mdi-home"
              type="text"
              label="주소"
              v-model="login.address"
            />
            <v-text-field
              id="address2"
              type="text"
              v-model="login.address2"
              class="pa-0 ml-8"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-left" cols="5">
            <a @click="change()" class="font-16">비밀번호변경</a>
          </v-col>
          <v-col class="text-right" cols="7">
            <v-btn class="mr-3 elevation-0 font-14" color="normal" @click.prevent="cancel()">취소</v-btn>
            <v-btn color="secondary" class="elevation-0 font-14" @click.prevent="update()">적용</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import util from '../utils/util'

export default {
  name: 'ModifyProfile',

  data () {
    return {
      login: null,
      levels: [],
      util: util
    }
  },

  props: {
    source: String,
  },

  methods: {
    update: function () {
      if (this.login.name.trim().length < 2) {
        alert('정확한 이름을 입력해주세요.')
        document.getElementById('name').focus()
        return
      }
      if (this.login.mobile.length < 10) {
        alert('정확한 휴대폰번호를 입력해주세요.')
        document.getElementById('mobile').focus()
        return
      }
      let params = new URLSearchParams()
      params.append('id', this.login.id)
      params.append('email', this.login.email)
      params.append('name', this.login.name.trim())
      params.append('sex', this.login.sex)
      params.append('birth', this.login.birth)
      params.append('mobile', this.login.mobile ? this.login.mobile : '')
      params.append('address', this.login.address ? this.login.address : '')
      params.append('address2', this.login.address2 ? this.login.address2 : '')
      axios.post('/api/user/modify', params, util.headers)
      .then(response => {
        if (response.data.error) {
          console.log(response.data.error)
        }
        else {
          let user = response.data.user
          util.getStudios((studios, error) => {
            if (error) console.log(error)
            user.studio_name = util.getItem(studios, user.studio).text
            localStorage.setItem('login', JSON.stringify(user))
            this.$emit('login', user)
            
            alert('내 정보가 변경되었습니다.')
            this.$router.push('/')
          })
        }
      })
    },

    cancel: function () {
      this.$router.push('/')
    },

    change: function () {
      this.$router.push('/change')
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(localStorage.getItem('login'))
    }
    if (this.login) {
      this.login.mobile = util.getPhoneNumber(this.login.mobile)
      this.$emit('login', this.login)
      
      util.getLevels((levels, error) => {
        if (error) console.log(error)
        this.levels = levels
      })
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.mb--20 {
  margin-bottom: -20px;
}
</style>
